import { combineReducers } from '@reduxjs/toolkit';

import aktivitetDomanerReducer from './aktivitetDomanerSlice';
import aktivitetReducer from './aktivitetSlice';
import domanerReducer from './bebyggelseobjektDomanerSlice';
import bebyggelseobjektReducer from './bebyggelseobjektSlice';
import bebyggelseobjektUtkastReducer from './bebyggelseobjektUtkastSlice';
import bebyggelseobjektVersionReducer from './bebyggelseobjektVersionSlice';
import bebyggelseobjektVersionerReducer from './bebyggelseobjektVersionerSlice';
import configurationReducer from './configurationSlice';
import drawerReducer from './drawerSlice';
import errorReducer from './errorSlice';
import featureInfoByggnaderReducer from './featureInfoByggnaderSlice';
import featureInfoInventeringarReducer from './featureInfoInventeringarSlice';
import geoReferensReducer from './geoReferensdataSlice';
import geopackageToGeoJSONReducer from './geopackageToGeoJSONSlice';
import mapReducer from './mapSlice';
import publiceradeBebyggelseobjektReducer from './publiceradeBebyggelseobjektSlice';
import searchAktivitetReducer from './searchAktivitetSlice';
import searchBebyggelseobjektReducer from './searchBebyggelseobjektSlice';
import upphovsmanOrganisationerReducer from './upphovsmanOrganisationerSlice';
import upphovsmanPersonerReducer from './upphovsmanPersonerSlice';
import upphovsmanReducer from './upphovsmanSlice';
import userReducer from './userSlice';
import utforarePagaendeAktiviteterReducer from './utforarePagaendeAktiviteterSlice';
import utforareReducer from './utforareSlice';
import utkastReducer from './utkastSlice';
import vinjettReducer from './vinjettSlice';

import { LMApi } from 'api/LMApi';
import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';

export const rootReducer = combineReducers({
  aktivitet: aktivitetReducer,
  aktivitetDomaner: aktivitetDomanerReducer,
  bebyggelseobjekt: bebyggelseobjektReducer,
  bebyggelseobjektDomaner: domanerReducer,
  bebyggelseobjektUtkast: bebyggelseobjektUtkastReducer,
  bebyggelseobjektVersion: bebyggelseobjektVersionReducer,
  bebyggelseobjektVersioner: bebyggelseobjektVersionerReducer,
  configuration: configurationReducer,
  drawer: drawerReducer,
  error: errorReducer,
  featureInfoByggnader: featureInfoByggnaderReducer,
  featureInfoInventeringar: featureInfoInventeringarReducer,
  geo: geoReferensReducer,
  geopackageToGeoJSON: geopackageToGeoJSONReducer,
  map: mapReducer,
  publiceradeBebyggelseobjekt: publiceradeBebyggelseobjektReducer,
  searchAktiviteter: searchAktivitetReducer,
  searchBebyggelseobjekt: searchBebyggelseobjektReducer,
  upphovsmanOrganisationer: upphovsmanOrganisationerReducer,
  upphovsmanPersoner: upphovsmanPersonerReducer,
  user: userReducer,
  utkast: utkastReducer,
  upphovsman: upphovsmanReducer,
  utforare: utforareReducer,
  utforarePagaendeAktiviteter: utforarePagaendeAktiviteterReducer,
  vinjett: vinjettReducer,
  [bebyggelseApiRTK.reducerPath]: bebyggelseApiRTK.reducer,
  [LMApi.reducerPath]: LMApi.reducer
});

export type RootState = ReturnType<typeof rootReducer>;
